import styled from 'styled-components';

export default styled.div<{ align?: 'right' }>`
  padding: ${props => props.theme.spacing(1)}px;
  text-align: ${props => props.align || 'left'};
`;
